import { Link } from "gatsby"
import styles from "./Kampanj.module.css"
import { Order } from "../formPage/FormPage"
import React from "react"
import { BookingButton } from "../atoms/Button"

const formatThousands = (num: number) =>
  num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")

const AM_PAKET_ID = 10474

const KampanjMoped: React.FC<{
  firstStart?: string
  priceNum?: number
  amPaket?: { masterPrice: number; masterVat: number; sellerArticlePackageMasterId: number; descriptionHeader: string }
  data: any
}> = ({ priceNum, amPaket, data }) => {
  const price = amPaket?.masterPrice ?? priceNum ?? 6_200
  const vat = amPaket?.masterVat ?? 798
  const id = amPaket?.sellerArticlePackageMasterId ?? AM_PAKET_ID
  const title = amPaket?.descriptionHeader ?? "Mopedkurs Göteborg"
  const priceStr = `${formatThousands(price)}kr`
  const ordinariePrisStr = "9 995 :-"
  return (
    <section className={styles.Kampanj}>
      <div>
        <h3 className={styles.title}>Paket Moped klass 1 – AM</h3>
        <div className={styles.mainRow}>
          <div>
            <ul className="mx-2">
              <li>Minst 10 timmar teori</li>
              <li>Minst 7 timmar praktisk körning</li>
              <li>Teoripaket (online teori)</li>
              <li>Totalt minst 17 timmar</li>
            </ul>
            <div className={styles.column}>
              <span className={styles.price}>
                {priceStr}{" "}
                <span
                  style={{ fontSize: "1.25rem", whiteSpace: "nowrap" }}
                >
                  (ordinarie pris {ordinariePrisStr})
                </span>
              </span>
            </div>
          </div>
          <div className="md:ml-3">
            <img src={require("./../../images/moped.jpg")} />
          </div>
        </div>
        <h2>Kommande kurser</h2>
        {data.map(row => (
          <div
            className="flex gap-4 py-1 px-1 whitespace-normal sm:whitespace-pre"
            key={row.datum[0]?.datum + "_moped"}
          >
            <div className="flex-1">Datum: {row.datum[0]?.text}</div>
            <div className="flex-1">Tid: {row.tid[0]?.text}</div>
            <div className="flex-1">Pris(kr): {row.pris[0]?.text}</div>
            <div className="flex-grow">{row.lediga_platser} lediga platser</div>
            {row.lediga_platser && row.lediga_platser > 0 ? (
              <Link
                to={"/formular"}
                state={{
                  orderType: Order.MOPED,
                  orderState: {
                    items: [
                      {
                        title,
                        price,
                        vat,
                        id,
                      },
                    ],
                  },
                  date: row.datum[0]?.text + ", " + row.tid[0]?.text,
                }}
              >
                <div css={BookingButton}>Boka</div>
              </Link>
            ) : (
              <div>Fullbokat!</div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}

export default KampanjMoped
